module.exports = function getResource(label, vars = []) {
    let resources = {
        availabletimes: 'Available times',
        noTimesAvailable: 'No times available',
        for: 'for',
        waitlist: 'Waitlist'
    };

    return resources[label];
};
